import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import { NumberField } from "."

export default function NumberFieldWrapper({ name, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setValue } = helpers

  const onChange = useCallback((_, val) => setValue(val ?? ""), [setValue])

  return (
    <NumberField
      {...field}
      error={error}
      onChange={onChange}
      touched={field.value ? touched : false}
      {...rest}
    />
  )
}

NumberFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
